export const wishlistsPagePath = '/wishlists/projects';